import Vue from "vue";
import Currency from "../../classes/Billing/Currency";

const state = {
    currencies: undefined,
};

const getters = {
    currencies(state) {
        return state.currencies;
    },
};

const mutations = {
    setCurrencies(state, currencies) {
        state.currencies = currencies.map(currency => new Currency(currency)).sort((a, b) => a.name > b.name ? 1 : -1);
    },
};

const actions = {
    async getCurrencies({ commit }) {
        const response = await Vue.prototype.$diceAPI.getCurrencies();
        commit("setCurrencies", response.data.map(currency => new Currency(currency)));
    },
    setCurrencies({ commit }, currencies) {
        commit("setCurrencies", currencies);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};